import {formatNumber} from "../../../helpers/format-number";

export class Section {

  constructor(sectionElement) {
    this.element = sectionElement;
    this.id = sectionElement.getAttribute('data-section');
  }

  static get allSectionElements() {
    return document.querySelectorAll('[data-section]');
  }

  static get allMainSections() {
    const SECTION_ELEMENT_ARRAY = Array.from(Section.allSectionElements)
    return SECTION_ELEMENT_ARRAY.filter(SECTION_ELEMENT => !SECTION_ELEMENT.hasAttribute('data-product'));
  }

  static deactivateMainSections() {
    Section.allMainSections.forEach(sectionElement => sectionElement.setAttribute('data-active', 'false'));
  }

  static showSectionById(sectionId) {
    Section.allSectionElements.forEach(sectionElement => {
      if (sectionElement.getAttribute('data-section') === sectionId || sectionElement.getAttribute('data-product') === sectionId) {
        sectionElement.setAttribute('data-active', 'true')
      } else {
        sectionElement.setAttribute('data-active', 'false')
      }
    })
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }

  static getStretchFilmString(stretchFilmCount) {
    let stretchFilmString = `${stretchFilmCount} Rolle`;
    return stretchFilmCount > 1 ? `${stretchFilmCount} Rollen` : stretchFilmString;
  }

  static updateAddressSection(addressData, addressListingElement) {
    Section.#updateBillingAddressSection(addressData, addressListingElement);
    Section.#updateShippingAddressSection(addressData, addressListingElement);
    Section.#updateContactSection(addressData, addressListingElement);
    Section.#updateMessageSection(addressData, addressListingElement);
  }

  static #updateBillingAddressSection(addressData, addressListingElement) {
    const BILLING_ADDRESS_ELEMENT = addressListingElement.querySelector('.billing-address');
    const PRE_NAME_FIELD = BILLING_ADDRESS_ELEMENT.querySelector('[data-address="preName"]');
    const LAST_NAME_FIELD = BILLING_ADDRESS_ELEMENT.querySelector('[data-address="lastName"]');
    const STREET_FIELD = BILLING_ADDRESS_ELEMENT.querySelector('[data-address="street"]');
    const ZIP_FIELD = BILLING_ADDRESS_ELEMENT.querySelector('[data-address="zip"]');
    const CITY_FIELD = BILLING_ADDRESS_ELEMENT.querySelector('[data-address="city"]');

    PRE_NAME_FIELD.innerText = addressData.preName || '';
    LAST_NAME_FIELD.innerText = addressData.lastName || '';
    STREET_FIELD.innerText = addressData.street || '';
    ZIP_FIELD.innerText = addressData.zip || '';
    CITY_FIELD.innerText = addressData.city || '';
  }

  static #updateShippingAddressSection(addressData, addressListingElement) {
    const SHIPPING_ADDRESS_ELEMENT = addressListingElement.querySelector('.shipping-address');

    const IS_DIFFER = addressData.differ || false;
    if (IS_DIFFER) SHIPPING_ADDRESS_ELEMENT.classList.remove('d-none');
    else SHIPPING_ADDRESS_ELEMENT.classList.add('d-none');

    const PRE_NAME_FIELD = SHIPPING_ADDRESS_ELEMENT.querySelector('[data-address="shippingPreName"]');
    const LAST_NAME_FIELD = SHIPPING_ADDRESS_ELEMENT.querySelector('[data-address="shippingLastName"]');
    const STREET_FIELD = SHIPPING_ADDRESS_ELEMENT.querySelector('[data-address="shippingStreet"]');
    const ZIP_FIELD = SHIPPING_ADDRESS_ELEMENT.querySelector('[data-address="shippingZip"]');
    const CITY_FIELD = SHIPPING_ADDRESS_ELEMENT.querySelector('[data-address="shippingCity"]');

    PRE_NAME_FIELD.innerText = addressData.shippingPreName || '';
    LAST_NAME_FIELD.innerText = addressData.shippingLastName || '';
    STREET_FIELD.innerText = addressData.shippingStreet || '';
    ZIP_FIELD.innerText = addressData.shippingZip || '';
    CITY_FIELD.innerText = addressData.shippingCity || '';
  }

  static #updateContactSection(addressData, addressListingElement) {
    const CONTACT_ELEMENT = addressListingElement.querySelector('.contact');
    const PHONE_FIELD = CONTACT_ELEMENT.querySelector('[data-address="phone"]');
    const EMAIL_FIELD = CONTACT_ELEMENT.querySelector('[data-address="email"]');

    const HAS_PHONE = addressData.phone !== '';

    if (HAS_PHONE) PHONE_FIELD.classList.remove('d-none');
    else PHONE_FIELD.classList.add('d-none');

    EMAIL_FIELD.innerText = addressData.email || '';
    PHONE_FIELD.innerText = addressData.phone ? `Tel. ${addressData.phone}` : '';
  }

  static #updateMessageSection(addressData, addressListingElement) {
    const MESSAGE_ELEMENT = addressListingElement.querySelector('.message');

    const MESSAGE = addressData.message || '';
    if (MESSAGE) MESSAGE_ELEMENT.classList.remove('d-none');
    else MESSAGE_ELEMENT.classList.add('d-none');

    const MESSAGE_FIELD = MESSAGE_ELEMENT.querySelector('[data-address="message"]');

    MESSAGE_FIELD.innerText = MESSAGE;
  }

  static updateShippingSection(ShippingSection, shippingData, shippingListingElement) {

    const SHIPPING_SERVICE_FIELD = shippingListingElement.querySelector('[data-shipping="service"]');

    const STRETCH_FILM_ELEMENT = shippingListingElement.querySelector('.stretch-film');
    const STRETCH_FILM_FIELD = STRETCH_FILM_ELEMENT.querySelector('[data-shipping="stretchFilm"]');

    const PACKAGE_STAMP_ELEMENT = shippingListingElement.querySelector('.package-stamp');
    const PACKAGE_STAMP_FIELD = PACKAGE_STAMP_ELEMENT.querySelector('[data-shipping="packageStamp"]');

    const DATE_ELEMENT = shippingListingElement.querySelector('.date');
    const DATE_FIELD = DATE_ELEMENT.querySelector('[data-shipping="date"]');

    SHIPPING_SERVICE_FIELD.innerText = shippingData.service ? ShippingSection.getShippingOptionName(shippingData.service) : '';

    if (shippingData.service === 'allInclusive' && parseInt(shippingData.stretchFilm) > 0) {
      STRETCH_FILM_ELEMENT.classList.remove('d-none');
      STRETCH_FILM_FIELD.innerText = ShippingSection.getStretchFilmString(parseInt(shippingData.stretchFilm));
    } else STRETCH_FILM_ELEMENT.classList.add('d-none');

    if (shippingData.service === 'package') {
      PACKAGE_STAMP_ELEMENT.classList.remove('d-none');
      PACKAGE_STAMP_FIELD.innerText = ShippingSection.getShippingStampName(shippingData.packageStamp);
      if (shippingData.packageStamp === 'package_surcharge_gls_pickup' || shippingData.packageStamp === 'package_surcharge_dhl_pickup') {
        DATE_ELEMENT.classList.remove('d-none');
        DATE_FIELD.innerText = shippingData.packageDate;
      } else DATE_ELEMENT.classList.add('d-none');

    } else PACKAGE_STAMP_ELEMENT.classList.add('d-none');

  }

  static updateProducts(productsArray, productListingElement) {
    productListingElement.innerText = '';

    productsArray.forEach(product => {
      const HTML_ELEMENT = product.getHtmlTemplate();
      productListingElement.append(HTML_ELEMENT)
    })
  }

  static updateDiscounts(CartSection, discountListingElement) {
    const CART_DISCOUNT_DATA = CartSection.priceData.cartDiscountData;

    discountListingElement.innerText = '';

    for (const [index, discountObject] of Object.entries(CART_DISCOUNT_DATA)) {
      if (discountObject.productDiscountTotal > 0) {
        const DISCOUNT_ITEM = CartSection.getDiscountHtmlTemplate(index, discountObject);
        discountListingElement.append(DISCOUNT_ITEM);
      }
    }
  }

  static updateShippingCosts(ShippingSection, shippingData, shippingCostElement) {
    const SHIPPING_PRICE_DATA = ShippingSection.priceData;
    const SHIPPING_COST_SLOT = shippingCostElement.querySelector('.value');
    const STRETCH_FILM_SLOT = shippingCostElement.querySelector('.stretch-film-slot');

    STRETCH_FILM_SLOT.innerText = '';
    SHIPPING_COST_SLOT.innerText = '';

    if (SHIPPING_PRICE_DATA.currentShippingPrice <= 0) shippingCostElement.classList.add('d-none');
    else shippingCostElement.classList.remove('d-none');

    STRETCH_FILM_SLOT.innerText = '';
    if (shippingData.service === 'allInclusive') {

      if (parseInt(shippingData.stretchFilm) > 0) {
        const STRETCH_FILM_PRICE = formatNumber(SHIPPING_PRICE_DATA.stretchFilmPrice);
        STRETCH_FILM_SLOT.innerText = ` (inkl. ${Section.getStretchFilmString(parseInt(shippingData.stretchFilm))} Stretchfolie – ${STRETCH_FILM_PRICE} €)`
      }
    }

    SHIPPING_COST_SLOT.innerText = formatNumber(SHIPPING_PRICE_DATA.currentShippingPrice);
  }

  static updateRetoureCost(ShippingSection, retoureCostElement) {
    const SHIPPING_PRICE_DATA = ShippingSection.priceData;
    const RETOURE_COST_SLOT = retoureCostElement.querySelector('.value');
    const RETOURE_PRICE = SHIPPING_PRICE_DATA.retourePrice

    const FORMATTED_RETOURE_PRICE = formatNumber(RETOURE_PRICE);

    RETOURE_COST_SLOT.innerText = '';
    RETOURE_COST_SLOT.innerText = RETOURE_PRICE <= 0 ? 'auf Anfrage' : `${FORMATTED_RETOURE_PRICE} €`;
  }

  static getTotalPriceToPay(cartPriceToPay, retourePrice, shippingPrice) {
    return Math.round(retourePrice) + Math.round(shippingPrice) + Math.round(cartPriceToPay);
  }

  static updatePriceTotal(CartSection, ShippingSection, totalPriceElement) {

    const CART_PRICE = CartSection.priceData;
    const SHIPPING_PRICE = ShippingSection.priceData;
    const CART_PRICE_TO_PAY = CART_PRICE.cartPriceToPay;
    const CURRENT_SHIPPING_PRICE_TOTAL = SHIPPING_PRICE.currentShippingPrice;
    const RETOURE_PRICE = SHIPPING_PRICE.retourePrice;
    const TOTAL_PRICE_SLOT = totalPriceElement.querySelector('.value');
    const PRICE_TOTAL = Section.getTotalPriceToPay(CART_PRICE_TO_PAY, CURRENT_SHIPPING_PRICE_TOTAL, RETOURE_PRICE);

    TOTAL_PRICE_SLOT.innerText = formatNumber(PRICE_TOTAL);
  }

  static updateFormFields(formFields, formData) {
    for (const FORM_FIELD of formFields) {
      const FORM_FIELD_NAME = FORM_FIELD.name;
      const FORM_FIELD_VALUE = formData[FORM_FIELD_NAME] ? `${formData[FORM_FIELD_NAME]}` : '';

      if (FORM_FIELD.type === 'number') {
        const MIN_VALUE = FORM_FIELD.getAttribute('min') || 0;

        if (FORM_FIELD.value === 'undefined') {
          FORM_FIELD.value = MIN_VALUE
        } else if (typeof FORM_FIELD.value === 'string' && (FORM_FIELD.value === '0' || parseInt(FORM_FIELD.value))) {
          FORM_FIELD.value = FORM_FIELD_VALUE;
        } else {
          FORM_FIELD.value = parseInt(FORM_FIELD_VALUE)
        }

      } else if (FORM_FIELD.type === 'checkbox') {
        FORM_FIELD.checked = FORM_FIELD_VALUE !== 'undefined' && FORM_FIELD_VALUE !== '' && FORM_FIELD_VALUE !== 'false'
      } else if (FORM_FIELD.type === 'radio') {
        FORM_FIELD.checked = FORM_FIELD.value === FORM_FIELD_VALUE
      } else if (FORM_FIELD.type === 'select-one') {

        const SELECTED_OPTION = FORM_FIELD.querySelector('option[selected]')?.value ?? false;

        if (!SELECTED_OPTION) {
          if (!FORM_FIELD_VALUE) return
          FORM_FIELD.value = FORM_FIELD_VALUE
        } else {
          const SELECTED_INDEX = FORM_FIELD.selectedIndex;
          FORM_FIELD.value = FORM_FIELD_VALUE;
        }
      } else {
        FORM_FIELD.value = FORM_FIELD_VALUE;
      }
    }
  }
}
